import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi.js';

const FEATURE_LABELS = {
  1: '친구 이름', 2: '강아지 이름', 3: '강아지 외모', 5: '가족 이름', 9: '가족 관계',
  12: '가족 성', 13: '친구 성별', 14: '친구 성', 15: '가족 사진', 16: '장난감', 17: '간식',
  18: '고양이 이름', 19: '고양이 외모',
}

const HeroManage = () => {
  const queryParams = new URLSearchParams(window.location.search)
  const heroNo = queryParams.get("heroNo")

  const [hero, setHero] = useState()
  const [features, setFeatures] = useState([])
  const [tasks, setTasks] = useState([])
  const [checkedTaskKeys, setCheckedTaskKeys] = useState([])

  useEffect(() => {
    if (!heroNo) return
    const load = async () => {
      const [featuresRes, summary, tasksRes] = await Promise.all([
        butterflyApi.getHeroFeatures(heroNo),
        butterflyApi.getSummary(),
        butterflyApi.getTasks(heroNo)
      ])
      const heroItem = summary.heroes?.find(h => h.heroNo == heroNo)
      setHero(heroItem)
      setFeatures(featuresRes?.items || [])
      if (tasksRes && tasksRes.length > 0) {
        const tasksByObj = Object.groupBy(tasksRes, (t) => `${t.heroNo}_${t.scriptNo}`)
        const tasksBy = Object.entries(tasksByObj).map(([key, items]) => ({
          key,
          heroNo: items[0].heroNo,
          scriptNo: items[0].scriptNo,
          registerDatetime: items[0].registerDatetime,
          items,
        }))
        tasksBy.sort((a, b) => b.registerDatetime - a.registerDatetime)
        setTasks(tasksBy)
      }
    }
    load()
  }, [heroNo])

  if (!heroNo) return <div className="px-4 mt-12">heroNo 파라미터가 필요합니다.</div>

  const taskKey = (t) => `${t.heroNo}_${t.scriptNo}`
  const toggleTaskCheck = (e, key) => {
    e.stopPropagation()
    setCheckedTaskKeys(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key])
  }

  const scriptNos = checkedTaskKeys.length > 0 && checkedTaskKeys.map(key => key.split("_")[1]).join(",")

  const checkNoty = async () => {
    await butterflyApi.updateNotifiedDate(heroNo, scriptNos)
    window.location.reload()
  }

  const handlePause = async () => {
    await butterflyApi.pauseHero(heroNo)
    window.location.reload()
  }

  const handleRelease = async () => {
    await butterflyApi.releaseHero(heroNo)
    window.location.reload()
  }

  const familyFeatures = features.filter(f => f.groupNo == 1)
  const friendFeatures = features.filter(f => f.groupNo == 2)
  const etcFeatures = features.filter(f => [16, 17].includes(f.heroFeatureNo))
  const dogFeatures = features.filter(f => [2, 3].includes(f.heroFeatureNo))
  const catFeatures = features.filter(f => [18, 19].includes(f.heroFeatureNo))

  const FeatureList = ({ items, title }) => {
    if (!items?.length) return null
    return <div className="mb-2">
      <div className="font-semibold text-sm text-gray-600">{title}</div>
      <div className="pl-2 text-sm">
        {items.map((f, i) => (
          <div key={f.heroFeatureContentNo || i}>
            {FEATURE_LABELS[f.heroFeatureNo] || `항목${f.heroFeatureNo}`}: {
              f.answer?.startsWith('http') ? <img src={f.graphicImageUrl || f.answer} className="w-16 h-16 object-cover inline" alt="" /> : f.answer
            }
          </div>
        ))}
      </div>
    </div>
  }

  return <div className="px-4 mt-12 max-w-2xl">
    <div className="mb-4 flex gap-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
      <a href="/manage/heroes" className="text-blue-600 underline">Heroes</a>
    </div>

    {scriptNos && <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
      <button onClick={checkNoty} className='text-blue-600 underline font-medium'>
        {heroNo}의 스크립트 {scriptNos} 발송 완료 체크
      </button>
    </div>}

    {hero && <div className="p-4 bg-gray-50 rounded-lg border">
      <div className="font-bold mb-3">주인공 설정</div>
      <div className="flex gap-4 mb-4">
        <div className="text-sm">
          <div><strong>이름</strong> {hero.name}</div>
          <div><strong>생년</strong> {hero.birthYear}</div>
          <div><strong>모습</strong> {hero.appearance}</div>
          <div><strong>성별</strong> {hero.gender == 'M' ? '남' : hero.gender == 'F' ? '여' : hero.gender}</div>
          <div><strong>동화제작 신청여부</strong> {hero.writingReady ? 'Y' : 'N'}</div>
          <div><strong>모습</strong> <img src={hero.graphicImageUrl} className="w-16 h-16 object-cover inline" alt="" /></div>
        </div>
      </div>
      <div className="text-sm space-y-2">
        <FeatureList items={familyFeatures} title="가족" />
        <FeatureList items={friendFeatures} title="친구" />
        <FeatureList items={dogFeatures} title="강아지" />
        <FeatureList items={catFeatures} title="고양이" />
        <FeatureList items={etcFeatures} title="기타" />
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href={`/manage/history?heroNo=${heroNo}`}>History</a>
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href={`/manage?heroNo=${heroNo}`}>Tasks</a>
      </div>
      <div className='my-4 flex gap-2'>
        {hero.writingReady
          ? <button onClick={handlePause} className='px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700'>작업 중지</button>
          : <button onClick={handleRelease} className='px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700'>작업 중지 해제</button>
        }
      </div>
    </div>}

    {!hero && heroNo && <div className="text-gray-500">로딩중...</div>}

    {tasks.length > 0 && <div className="mt-8">
      <div className="font-bold text-lg mb-2">Tasks</div>
      {[...tasks].sort((a, b) => {
        const aNotify = a.items[0].notifyDatetime
        const bNotify = b.items[0].notifyDatetime
        if (!aNotify && bNotify) return -1
        if (aNotify && !bNotify) return 1
        return 0
      }).map(task => {
        const items = task.items
        const key = taskKey(task)
        const checked = checkedTaskKeys.includes(key)
        const noNotify = !items[0].notifyDatetime
        return (
          <div key={key} className={`mt-4 border-2 p-4 flex gap-5 items-start cursor-pointer hover:bg-gray-50 ${noNotify ? 'border-red-400 bg-red-50' : ''}`}
            onClick={() => { window.location.href = `/manage/story?heroNo=${items[0].heroNo}&scriptNo=${items[0].scriptNo}` }}>
            <div className="flex-shrink-0 pt-1" onClick={e => { e.preventDefault(); e.stopPropagation(); toggleTaskCheck(e, key); }}>
              <input type="checkbox" checked={checked} readOnly className="w-4 h-4 cursor-pointer" />
            </div>
            <div className='w-24 flex-shrink-0'>
              <img src={items[0].imageUrl} alt="" />
            </div>
            <div className="text-sm">
              <div>검증일 : {items[0].verifiedDatetime}</div>
              <div>노티일 : {items[0].notifyDatetime}</div>
              <div>조회일 : {items[0].lastViewDatetime}</div>
              <div>scriptNo : {items[0].scriptNo}</div>
              <div>title : {items[0].title}</div>
            </div>
          </div>
        )
      })}
    </div>}
  </div>
}

export default HeroManage
